import api from '../api/api';

// Load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

// Process payment with Razorpay
const processPayment = async (course, user) => {
  try {
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) {
      throw new Error('Failed to load Razorpay SDK');
    }

    // 1. Get Razorpay Key from backend
    const keyResponse = await api.get('/payments/razorpay-key');
    const razorpayKey = keyResponse.data.data.keyId;

    // 2. Create Order from backend
    const orderResponse = await api.post(`/payments/create-razorpay-order?courseId=${course.id}`);
    const order = orderResponse.data.data;

    return new Promise((resolve, reject) => {
      const options = {
        key: razorpayKey,
        amount: order.amount,
        currency: order.currency,
        name: 'Course Platform',
        description: `Payment for ${course.title}`,
        order_id: order.id,
        handler: async (response) => {
          try {
            // 3. Verify Payment with backend
            const verificationResponse = await api.post(
              `/payments/verify-payment?razorpayOrderId=${response.razorpay_order_id}&razorpayPaymentId=${response.razorpay_payment_id}&razorpaySignature=${response.razorpay_signature}`
            );
            resolve(verificationResponse.data);
          } catch (error) {
            reject(error.response?.data?.message || 'Payment verification failed');
          }
        },
        prefill: {
          name: user.fullName,
          email: user.email,
        },
        theme: {
          color: '#667eea',
        },
        modal: {
          ondismiss: () => {
            reject(new Error('Payment cancelled by user.'));
          },
        },
      };

      const razorpayInstance = new window.Razorpay(options);
      razorpayInstance.on('payment.failed', (response) => {
        reject(new Error(response.error.description));
      });
      razorpayInstance.open();
    });
  } catch (error) {
    throw error.response?.data?.message || error.message || 'An error occurred during payment processing.';
  }
};

// --- NEW: Process payment for RESOURCE (Notes/Mock Tests) ---
const processResourcePayment = async (resource, user) => {
  try {
    const scriptLoaded = await loadRazorpayScript();
    if (!scriptLoaded) throw new Error('Failed to load Razorpay SDK');

    const keyResponse = await api.get('/payments/razorpay-key');
    const razorpayKey = keyResponse.data.data.keyId;

    // Call the specific resource order endpoint
    const orderResponse = await api.post(`/payments/create-razorpay-order/resource?resourceId=${resource.id}`);
    const order = orderResponse.data.data;

    return new Promise((resolve, reject) => {
      const options = {
        key: razorpayKey,
        amount: order.amount, // in paisa
        currency: order.currency,
        name: 'Lawfullingo',
        description: `Purchase: ${resource.title}`,
        order_id: order.id,
        handler: async (response) => {
          try {
            // Verify using the unified verification endpoint
            const verificationResponse = await api.post(
              `/payments/verify-payment?razorpayOrderId=${response.razorpay_order_id}&razorpayPaymentId=${response.razorpay_payment_id}&razorpaySignature=${response.razorpay_signature}`
            );
            resolve(verificationResponse.data);
          } catch (error) {
            reject(error.response?.data?.message || 'Payment verification failed');
          }
        },
        prefill: { name: user.fullName, email: user.email },
        theme: { color: '#0f172a' },
      };
      const rzp = new window.Razorpay(options);
      rzp.open();
    });
  } catch (error) {
    throw error.response?.data?.message || error.message || 'Payment failed';
  }
};

const paymentService = {
  processPayment,
  processResourcePayment, // Export the new method
};

export default paymentService;